import { Outlet } from "react-router-dom";

const Layout = () => {
  return (
    <div className="min-h-screen w-full bg-background text-foreground font-sans">
      <main className="mx-auto w-full max-w-md min-h-screen">
        <Outlet />
      </main>
    </div>
  );
};

export default Layout;
